import { Pipe, PipeTransform } from '@angular/core';
import { MenuItem } from '../interfaces/menu-item';

/**
 * Compares two sortOrder strings with hierarchical dot notation (e.g., "1.6", "1.6.1", "1.7")
 * @param sortOrderA First sortOrder string
 * @param sortOrderB Second sortOrder string
 * @returns negative if sortOrderA < sortOrderB, positive if sortOrderA > sortOrderB, 0 if equal
 */
function compareSortOrder(sortOrderA: string, sortOrderB: string): number {
  if (!sortOrderA && !sortOrderB) return 0;
  if (!sortOrderA) return 1;
  if (!sortOrderB) return -1;

  const segmentsA = sortOrderA.split('.').map(Number);
  const segmentsB = sortOrderB.split('.').map(Number);
  const maxSegments = Math.max(segmentsA.length, segmentsB.length);

  for (let index = 0; index < maxSegments; index++) {
    const difference = (segmentsA[index] || 0) - (segmentsB[index] || 0);
    if (difference !== 0) return difference;
  }
  return 0;
}

// Pipe to get parent menu items (those without a parentCategoryId)
@Pipe({ name: 'menuParents', standalone: true })
export class MenuParentsPipe implements PipeTransform {
  transform(items: MenuItem[]): MenuItem[] {
    if (!items) return [];
    return [...items]
      .filter((item) => item.parentCategoryId === null || item.parentCategoryId === undefined)
      .sort((itemA, itemB) => compareSortOrder(itemA.sortOrder, itemB.sortOrder));
  }
}

// Pipe to get child menu items based on parentCategoryId
@Pipe({ name: 'menuChildren', standalone: true })
export class MenuChildrenPipe implements PipeTransform {
  transform(items: MenuItem[], parentCategoryId: number): MenuItem[] {
    if (parentCategoryId === undefined || parentCategoryId === null || !items) return [];
    return [...items]
      .filter((item) => item.parentCategoryId === parentCategoryId)
      .sort((itemA, itemB) => compareSortOrder(itemA.sortOrder, itemB.sortOrder));
  }
}
